import { createTheme } from '@mui/material';

export const themeOptions = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#efa21e',
      /*  main: '#343745', */
      light: '#fff5e6'
    },
    secondary: {
      main: '#343745',
      light: '#343745',
      dark: '#1d1e26', 
    },
    background: {
      default: '#fcfcfd'
    },
    text: {
      /* primary: '#5e6278', */
      primary: '#000',
      secondary: '#343745',
      disabled: '#d0d5dd'
    },
    error: {
      main: '#ba1a1a'
    },
    divider: {
      main: '#eaecf0'
    }
  },
  typography: {
    fontFamily: ['-apple-system', 'BlinkMacSystemFont', 'Inter', 'sans-serif'].join(',')
  }
});
